import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { useAuthStore } from "./store/auth";
import { isExpired } from "./lib/auth";
import { Dashboard } from "./pages/Dashboard";
import { LeadDetail } from "./pages/Leads/LeadDetail";
import { LeadsList } from "./pages/Leads/LeadsList";
import { Login } from "./pages/Login";
function RequireAuth({ children }) {
    const token = useAuthStore((state) => state.token);
    const logout = useAuthStore((state) => state.logout);
    if (!token || isExpired(token)) {
        if (token)
            logout();
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return children;
}
export default function App() {
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsxs(Route, { path: "/", element: _jsx(RequireAuth, { children: _jsx(Layout, {}) }), children: [_jsx(Route, { index: true, element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "leads", element: _jsx(LeadsList, {}) }), _jsx(Route, { path: "leads/:id", element: _jsx(LeadDetail, {}) })] })] }) }));
}
